import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

//PAGES
import { ChangepassPage } from '../changepass/changepass';
import { ViewEntregaPage } from '../view-entrega/view-entrega';
import { WelcomePage } from '../welcome/welcome';

//PROVIDERS
import { Services, Tools, User } from '../../providers';

@IonicPage()
@Component({
  selector: 'page-entregas',
  templateUrl: 'entregas.html',
})
export class EntregasPage {
  entregas:any=[];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private services: Services,
    private tools: Tools,
    private user: User
  ){}

  ionViewDidLoad(){
    // if(!this.user.getUser().changePass){
    //   this.navCtrl.push(ChangepassPage);
    //   return;
    // }
    this.loadList();
  }

  loadList(){
    var loading = this.tools.showLoading('Carregando...');
    loading.present();
    let motId = this.user.getUser()._id+'';
    let query = {ativo:true,motoristaId:motId,status:{$in:['gray','primary']}}

    this.services.getData('cadRotas',query,(result)=>{
      if(result.data.length == 0){
        this.tools.showAlert('toast','Você não tem nenhuma entrega pedente.');
        loading.dismiss();
        return
      }
      this.entregas = result.data;
      loading.dismiss();
    });
  }

  openPedido(pedido:any){
    this.navCtrl.push(ViewEntregaPage,{item:pedido});
  }

  logout(){
    var x = confirm('Sair?');
    if(!x){return}

    this.navCtrl.setRoot(WelcomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/entregas/entregas.ts